export default class LanguageService {

  translateLikelihoodConversionToView(){
    const { first_likelihood, second_likelihood, third_likelihood, fourth_likelihood, fifth_likelihood, not_applicable } = this.state.translations
    return {
      '1' : first_likelihood.trim(),
      '2' : second_likelihood.trim(),
      '3' : third_likelihood.trim(),
      '4' : fourth_likelihood.trim(),
      '5' : fifth_likelihood.trim(),
      'N/A' : not_applicable.trim()
    }
  }

  translateRiskRatingDict(){
    const { low, medium, high, significant, na_abbre} = this.state.translations
    return {
      "1" : {
        1 : { class: 'low-rating', label: low },
        3 : { class: 'low-rating', label: low },
        6 : { class: 'medium-rating', label: medium },
        10 : { class: 'medium-rating', label: medium },
        15: { class: 'significant-rating', label: significant }
      },
      "2" : {
        2 : { class: 'low-rating', label: low },
        5 : { class: 'low-rating', label: low },
        9 : { class: 'medium-rating', label: medium },
        14 : { class: 'significant-rating', label: significant },
        19: { class: 'significant-rating', label: significant }
      },
      "3" : {
        4 : { class: 'low-rating', label: low },
        8 : { class: 'medium-rating', label: medium },
        13 : { class: 'significant-rating', label: significant },
        18 : { class: 'significant-rating', label: significant },
        22: { class: 'high-rating', label: high }
      },
      "4" : {
        7 : { class: 'medium-rating', label: medium },
        12 : { class: 'medium-rating', label: medium },
        17 : { class: 'significant-rating', label: significant },
        21 : { class: 'high-rating', label: high },
        24 : { class: 'high-rating', label: high }
      },
      "5" : {
        11 : { class: 'medium-rating', label: medium },
        16 : { class: 'significant-rating', label: significant },
        20 : { class: 'significant-rating', label: significant },
        23 : { class: 'high-rating', label: high },
        25: { class: 'high-rating', label: high }
      },
      'N/A' : {
        0 : { class: '', label: na_abbre }
      }
    }
  }

  translateLikelihoodOptions(){
    const { first_likelihood, second_likelihood, third_likelihood, fourth_likelihood, fifth_likelihood, not_applicable } = this.state.translations
    return [
      {
        key: '1 – Rare ( > 30 years)',
        value: '1 – Rare ( > 30 years)',
        text: first_likelihood
      },
      {
        key: '2 – Unlikely (30 years)',
        value: '2 – Unlikely (30 years)',
        text: second_likelihood
      },
      {
        key: '3 – Possible (10 years)',
        value: '3 – Possible (10 years)',
        text: third_likelihood
      },
      {
        key: '4 – Likely (3 years)',
        value: '4 – Likely (3 years)',
        text: fourth_likelihood
      },
      {
        key: '5 – Almost Certain (1 year)',
        value: '5 – Almost Certain (1 year)',
        text: fifth_likelihood
      },
      {
        key: '(N/A) Not Applicable',
        value: '(N/A) Not Applicable',
        text: not_applicable
      }
    ];
  }

  translateControlTagOptions = (translations) => {
    const { admin, critical, elim, eng_ing, sub, ppe_epp } = translations
    return [
      {
        key: 'Critical',
        value: 'Critical',
        text: critical
      },
      {
        key: 'Eliminate',
        value: 'Eliminate',
        text: elim
      },
      {
        key: 'Substitution',
        value: 'Substitution',
        text: sub
      },
      {
        key: 'Engineering',
        value: 'Engineering',
        text: eng_ing
      },
      {
        key: 'Admin',
        value: 'Admin',
        text: admin
      },
      {
        key: 'PPE',
        value: 'PPE',
        text: ppe_epp
      },
    ]
  }

  translateRiskTagOptions = (translations) => {
    const { pue } = translations;
    return [
      {
        key: 'PUE',
        value: 'PUE',
        text: pue
      }
    ]
  }

  translateTagOptions = (translations) => {
    return this.translateRiskTagOptions(translations).concat(this.translateControlTagOptions(translations))
  }


  static translateBusinessAreaTagOptions = (translations) => {
    return [
      'Agua Verde (Chile)',
      'Diamantina',
      'Exploradora (Chile)',
      'Generativo Argentina',
      'Generativo Chile',
      'Generativo Peru',
      'Group Discovery & Geosciences',
      'Near Asset Los Bronces (Chile)',
      'Near Asset Quellaveco (Peru)',
      'Regional Office',
      'Reliquias (Peru)',
      'Southwest Yilgarn'
    ].map((businessArea) => ({
      key: businessArea,
      value: businessArea,
      text: translations[businessArea] || businessArea
    }))
  }
}



// WEBPACK FOOTER //
// ./src/services/languageService.js